import {format} from 'date-fns';
import {ColumnType} from '@shared/helper/reflections';
import {isNull} from 'lodash-es';
import {formatInThaiZone} from '@shared/helper/helpers';

// tslint:disable-next-line:no-shadowed-variable
const date = (date: Date | number, fmt: 'short' | 'long' = 'short') => {
    if (fmt === 'short') {
        return format(date, 'dd/MM/yyyy');
    } else {
        return format(date, 'EEEEEE dd/MM/yyyy');
    }
};

// tslint:disable-next-line:no-shadowed-variable
const time = (date: Date | number) => format(date, 'HH:mm');

const comma = (n: number) => n.toLocaleString();

const transform = (value: any, type: ColumnType, ifNull?: string): string => {
    if (isNull(value)) {
        return ifNull ?? '--';
    }

    try {
        if (type === 'number') {
            return value ? value.toLocaleString() : ifNull ?? 0;
        } else if (type === 'boolean') {
            return value ? 'Yes' : '-';
        } else if (type === 'date') {
            return formatInThaiZone(value, 'dd/MM/yyyy');
        } else if (type === 'date-medium') {
            return formatInThaiZone(value, 'EE dd/MM/yyyy');
        } else if (type === 'date-long') {
            return formatInThaiZone(value, 'EE dd MMMM yyyy');
        } else if (type === 'dateTime') {
            return formatInThaiZone(value, 'dd/MM/yyyy HH:mm');
        } else if (type === 'time') {
            return formatInThaiZone(value, 'HH:mm');
        } else if (type === 'dayOfWeek') {
            return formatInThaiZone(value, 'EE');
        } else {
            return value;
        }
    } catch (e) {
        console.warn({value, type, e});
        return '?';
    }
};

export const strings = {
    date,
    time,
    comma,
    transform
};
